class StatusDemandaEnum {
  constructor() {
    this.CARREGANDO = 1;
    this.SUSPENSO = 2;
    this.FINALIZADO = 3;
  }

  getTiposLabel() {
    return [
      {
        label: 'Carregando',
        value: this.CARREGANDO,
        active: true,
      },
      {
        label: 'Suspenso',
        value: this.SUSPENSO,
        active: true,
      },
      {
        label: 'Finalizado',
        value: this.FINALIZADO,
        active: true,
      },
    ];
  }

  getTipo(direcionamento) {
    return this.getTiposLabel()
      .filter(label => label.value === direcionamento)
      .shift();
  }
}

export default new StatusDemandaEnum();
